import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined"
import SettingsSuggestOutlinedIcon from '@mui/icons-material/SettingsSuggestOutlined'

const StaffMenu = {
    id: 'staffRoot',
    title: 'STAFFS',
    type: 'group',
    icon: GroupAddOutlinedIcon,
    children: [
        {
            id: 'users',
            title: 'Staffs',
            type: 'item',
            icon: GroupAddOutlinedIcon,
            url: '/users'
        },
        {
            id: 'treatmentSetting',
            title: 'Treatment Rate Setting',
            type: 'item',
            icon: SettingsSuggestOutlinedIcon,
            url: '/user/treatmentSetting'
        }
    ]
}
export default StaffMenu